// Topicpflicht beim Einlegen (Vertrag 26.1): eine Regel für den Wizard. Mit Schalter ist das Topic immer Pflicht,
// und „Standard DEV“ entfällt; ohne Schalter gilt die Space-Einstellung requireTopicSelection wie bisher.
export function topicRequirement({ requireTopicSelection = false, stageBranchesEnabled = false } = {}) {
  return { required: requireTopicSelection === true || stageBranchesEnabled === true, allowDefault: stageBranchesEnabled !== true };
}

export default topicRequirement;
